import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71b2f5a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt_5 text-ct" }
const _hoisted_4 = { class: "abs mask" }
const _hoisted_5 = ["onClick"]

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import Upload from './Upload.vue'
import ImgTooltip from './ImgTooltip.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['img', 'force'],
  emits: ['change'],
  setup(__props, { emit }) {

const props = __props



const upload = require('@/assets/image/icon/upload.png')

const data = ref(props.force ? '' : props.img)

watch(data, (val) => {
  if (val) {
    emit('change', val)
  }
})

const del: any = ref(null)

const replace = () => {
  if (props.img === data.value) {
    data.value = ''
    emit('change', '')
  }
  del.value && del.value()
}

return (_ctx: any,_cache: any) => {
  return (!data.value)
    ? (_openBlock(), _createBlock(Upload, {
        key: 0,
        onChange: _cache[0] || (_cache[0] = (val) => (data.value = val?.raw?.url ?? '')),
        "limit-file": {
      accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG'
    }
      }, {
        trigger: _withCtx(({ delFile }) => [
          _createElementVNode("div", {
            class: "upload-icon flex-col flex-center",
            onClick: ($event: any) => (del.value = delFile)
          }, [
            _createElementVNode("img", {
              src: _unref(upload),
              class: "upload-icon-icon"
            }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('上传图片')), 1)
          ], 8, _hoisted_1)
        ]),
        _: 1
      }, 8, ["limit-file"]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
        _createElementVNode("div", {
          class: _normalizeClass(["rel upload-wrap flex btn", { active: __props.img === data.value }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('change', data.value)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", {
              class: "btn fa fa-trash",
              onClick: _withModifiers(replace, ["stop"])
            }, null, 8, _hoisted_5)
          ]),
          _createVNode(ImgTooltip, {
            src: data.value,
            class: "upload-img",
            height: "160px"
          }, null, 8, ["src"])
        ], 2)
      ])
}
}

})